const EMBED_KEY_PATTERN = /^[a-z0-9_]{1,64}$/;
// Instrument context, then monitor filters (country and theme may repeat).
const EMBED_CONTEXT_PARAMS = [
  "instrument",
  "ccyPair",
  "country",
  "theme",
  "start_date",
  "end_date",
];

// Maps a launch URL's ?embed=<key>&instrument=<PAIR> to the relative /embed
// route, forwarding only whitelisted context params. Returns null if invalid.
export const resolveEmbedRoute = (embedKey, search = "") => {
  if (!embedKey || !EMBED_KEY_PATTERN.test(embedKey)) {
    return null;
  }

  const source = new URLSearchParams(search);
  const forwarded = new URLSearchParams();
  EMBED_CONTEXT_PARAMS.forEach((name) => {
    source.getAll(name).forEach((value) => {
      if (value) forwarded.append(name, value);
    });
  });
  const query = forwarded.toString();
  return `/embed/${embedKey}${query ? `?${query}` : ""}`;
};
